import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Collapse from 'react-bootstrap/Collapse';
import Swal from 'sweetalert2';
import LocationServices from '../../../services/LocationServices';
import { Modal, Button, Container, Row, Col } from "react-bootstrap";

const LocationAddModel = ({ onSuccess, show, handleClose, test }) => {
  const [open2, setOpen2] = useState(true);
  const [selectedState, setSelectedState] = useState('');
  const user = JSON.parse(localStorage.getItem("userDetails"));
  const userId = user?.data?.user?._id;

  const initialForm = {
    name: '',
    location: '',
    user: userId,
    address: {
      street: '',
      city: '',
      state: '',
      pincode: '',
      country: 'India',
      user: userId
    },
  };

  const [formValues, setFormValues] = useState(initialForm);

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name === 'state') {
      setSelectedState(value);
      setFormValues((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          state: value,
          city: '', // Reset city when state changes
        },
      }));
    } else if (name === 'city') {
      setFormValues((prev) => ({
        ...prev,
        address: {
          ...prev.address,
          city: value,
        },
      }));
    } else if (['street', 'pincode', 'country'].includes(name)) {
      setFormValues((prev) => ({
        ...prev,
        address: { ...prev.address, [name]: value },
      }));
    } else {
      setFormValues((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { name, location, address } = formValues;
    const { street, city, state, pincode, country } = address;

    if (!name.trim()) {
      return Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Store Name is required!',
      });
    }

    if (!location.trim()) {
      return Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Location is required!',
      });
    }

    if (!street.trim()) {
      return Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Street is required!',
      });
    }

    if (!state.trim()) {
      return Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'State is required!',
      });
    }

    if (!city.trim()) {
      return Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'City is required!',
      });
    }

    if (!pincode.trim()) {
      return Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Pincode is required!',
      });
    }

    if (!country.trim()) {
      return Swal.fire({
        icon: 'error',
        title: 'Validation Error',
        text: 'Country is required!',
      });
    }
    try {
      const response = await LocationServices.addStore(formValues);
      if (response.status === 'success') {
        Swal.fire({
          icon: 'success',
          title: 'Good job!',
          text: 'Location Added Successfully!',
        });
        setFormValues(initialForm);
        setSelectedState('');
        handleClose();
        onSuccess?.();
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Failed to add Location',
        });
      }
    } catch (error) {
      console.error('Add Location Error:', error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: 'Failed to add Location',
      });
    }
  };


  const stateCityData = {
    "Andhra Pradesh": [
      "Visakhapatnam", "Vijayawada", "Guntur", "Nellore", "Tirupati", "Kakinada",
      "Rajahmundry", "Kadapa", "Anantapur", "Kurnool", "Eluru", "Ongole", "Chittoor",
      "Vizianagaram", "Srikakulam", "Machilipatnam", "Tenali", "Bhimavaram", "Adoni",
      "Madanapalle", "Nandyal", "Proddatur", "Hindupur", "Tadepalligudem",
      "Gudivada", "Dharmavaram", "Guntakal", "Narasaraopet", "Tadipatri", "Kavali"
    ],
    "Arunachal Pradesh": [
      "Itanagar", "Naharlagun", "Pasighat", "Aalo", "Seppa", "Tezu", "Daporijo", "Namsai",
      "Ziro", "Roing", "Tawang", "Khonsa", "Bomdila", "Deomali", "Changlang", "Miao",
      "Basar", "Dirang", "Anini", "Koloriang", "Rupa", "Boleng", "Hawai", "Jairampur",
      "Yingkiong", "Hayuliang", "Longding", "Pangin", "Likabali", "Miao"
    ],
    "Assam": [
      "Guwahati", "Silchar", "Dibrugarh", "Jorhat", "Nagaon", "Tezpur", "Tinsukia",
      "Bongaigaon", "Diphu", "Dhubri", "North Lakhimpur", "Karimganj", "Sivasagar",
      "Goalpara", "Barpeta", "Golaghat", "Lumding", "Haflong", "Rangia", "Mangaldoi",
      "Lanka", "Hojai", "Barpeta Road", "Kokrajhar", "Hailakandi", "Dhekiajuli", "Dergaon"
    ],
    "Bihar": [
      "Patna", "Gaya", "Bhagalpur", "Muzaffarpur", "Purnia", "Darbhanga", "Bihar Sharif",
      "Arrah", "Begusarai", "Katihar", "Munger", "Chhapra", "Sasaram", "Bettiah",
      "Motihari", "Saharsa", "Hajipur", "Dehri", "Siwan", "Sitamarhi", "Jamalpur",
      "Jehanabad", "Aurangabad (Bihar)", "Buxar", "Kishanganj", "Nawada", "Bagaha", "Danapur"
    ],
    "Chhattisgarh": [
      "Raipur", "Bhilai", "Durg", "Bilaspur", "Korba", "Rajnandgaon", "Raigarh",
      "Jagdalpur", "Ambikapur", "Chirmiri", "Dhamtari", "Mahasamund", "Bhatapara",
      "Dalli‑Rajhara", "Kawardha", "Champa", "Dongragarh", "Tilda Neora", "Mungeli",
      "Manendragarh", "Kondagaon", "Gobranawapara", "Bemetara", "Baikunthpur"
    ],
    "Goa": [
      "Panaji", "Vasco da Gama", "Margao", "Mapusa", "Ponda", "Bicholim", "Curchorem",
      "Sanquelim", "Valpoi", "Quepem", "Canacona", "Sanguem", "Cuncolim", "Pernem", "Mormugao"
    ],
    "Gujarat": [
      "Ahmedabad", "Surat", "Vadodara", "Rajkot", "Bhavnagar", "Jamnagar", "Junagadh",
      "Gandhinagar", "Anand", "Navsari", "Surendranagar", "Morbi", "Gandhidham",
      "Nadiad", "Bharuch", "Patan", "Porbandar", "Mehsana", "Bhuj", "Veraval", "Vapi",
      "Valsad", "Godhra", "Palanpur", "Kalol", "Botad", "Amreli", "Deesa", "Dahod",
      "Ankleshwar", "Jetpur"
    ],
    "Haryana": [
      "Gurugram", "Faridabad", "Ambala", "Panipat", "Yamunanagar", "Karnal", "Hisar",
      "Panchkula", "Rohtak", "Rewari", "Jind", "Sonipat", "Narnaul", "Kaithal",
      "Pehowa", "Kurukshetra", "Bahadurgarh"
    ],
    "Himachal Pradesh": [
      "Shimla", "Mandi", "Solan", "Dharamshala", "Hamirpur", "Bilaspur", "Una",
      "Chamba", "Palampur", "Kangra", "Nadaun"
    ],
    "Jharkhand": [
      "Ranchi", "Jamshedpur", "Dhanbad", "Bokaro", "Deoghar", "Hazaribagh",
      "Giridih", "Jharia", "Ramgarh", "Phusro", "Chas", "Medininagar"
    ],
    "Karnataka": [
      "Bengaluru", "Mysuru", "Hubli-Dharwad", "Mangaluru", "Belagavi", "Kalaburagi",
      "Davangere", "Ballari", "Shivamogga", "Tumakuru", "Udupi", "Vijayapura",
      "Bidar", "Raichur", "Hassan", "Karwar", "Chitradurga"
    ],
    "Kerala": [
      "Thiruvananthapuram", "Kochi", "Kozhikode", "Thrissur", "Alappuzha", "Kollam",
      "Palakkad", "Kannur", "Kottayam", "Malappuram", "Pathanamthitta", "Thalassery",
      "Ponnani", "Wayanad", "Attingal", "Pala", "Perinthalmanna"
    ],
    "Madhya Pradesh": [
      "Indore", "Bhopal", "Jabalpur", "Gwalior", "Ujjain", "Sagar", "Dewas", "Satna",
      "Rewa", "Ratlam", "Chhindwara", "Dhar", "Morena", "Guna", "Neemuch", "Vidisha",
      "Shivpuri", "Sehore", "Burhanpur"
    ],
    "Maharashtra": [
      "Mumbai", "Pune", "Nagpur", "Thane", "Nashik", "Kalyan-Dombivli", "Vasai-Virar",
      "Aurangabad", "Solapur", "Amravati", "Navi Mumbai", "Kolhapur", "Ulhasnagar",
      "Nanded", "Kharghar", "Panvel", "Akola", "Latur", "Malegaon"
    ],
    "Manipur": [
      "Imphal", "Churachandpur", "Thoubal", "Kakching", "Moirang", "Yairipok",
      "Wangjing", "Lilong", "Nambol", "Sekmai Bazar", "Mayang Imphal", "Kumbi",
      "Wabagai", "Lamsang", "Sugnu"
    ],
    "Meghalaya": [
      "Shillong", "Tura", "Nongpoh", "Jowai", "Baghmara", "Williamnagar",
      "Resubelpara", "Nongstoin", "Mairang", "Mawkyrwat", "Sohra", "Khliehriat"
    ],
    "Mizoram": [
      "Aizawl", "Lunglei", "Saiha", "Champhai", "Serchhip", "Kolasib",
      "Lawngtlai", "Mamit", "Saitual", "Hnahthial", "North Vanlaiphai"
    ],
    "Nagaland": [
      "Dimapur", "Kohima", "Mokokchung", "Tuensang", "Zunheboto", "Wokha",
      "Mon", "Phek", "Chumukedima", "Kiphire", "Peren", "Longleng"
    ],
    "Odisha": [
      "Bhubaneswar", "Cuttack", "Rourkela", "Brahmapur", "Sambalpur", "Puri",
      "Balasore", "Baripada", "Bhadrak", "Angul", "Balangir", "Barbil", "Bargarh",
      "Bhanjanagar", "Bhawanipatna", "Byasanagar", "Chatrapur", "Dhenkanal", "Gunupur",
      "Hinjilicut", "Jagatsinghapur", "Jajpur Road", "Jharsuguda", "Joda", "Kendrapara",
      "Kendujhar", "Koraput", "Malkangiri", "Paradip", "Paralakhemundi", "Phulbani",
      "Rayagada", "Talcher"
    ],
    "Punjab": [
      "Ludhiana", "Amritsar", "Jalandhar", "Patiala", "Bathinda", "Mohali",
      "Hoshiarpur", "Moga", "Batala", "Pathankot", "Abohar", "Malerkotla",
      "Khanna", "Muktsar", "Barnala", "Firozpur", "Phagwara", "Rajpura", "Mukerian"
    ],
    "Rajasthan": [
      "Jaipur", "Jodhpur", "Kota", "Bikaner", "Ajmer", "Udaipur", "Bhilwara",
      "Alwar", "Sikar", "Pali", "Sri Ganganagar", "Hanumangarh", "Jhunjhunu",
      "Churu", "Tonk", "Bharatpur", "Baran", "Banswara", "Dausa", "Nagaur",
      "Jhalawar", "Sawai Madhopur", "Chittorgarh", "Dholpur", "Karauli"
    ],
    "Sikkim": [
      "Gangtok", "Namchi", "Geyzing", "Mangan", "Singtam", "Rangpo",
      "Jorethang", "Soreng", "Pakyong", "Rhenock", "Yuksom"
    ],
    "Tamil Nadu": [
      "Chennai", "Coimbatore", "Madurai", "Tiruchirappalli", "Salem", "Tirunelveli",
      "Tiruppur", "Vellore", "Erode", "Thoothukudi", "Dindigul", "Thanjavur",
      "Nagercoil", "Kanchipuram", "Karur", "Ambur", "Cuddalore", "Pudukkottai",
      "Sivakasi", "Nagapattinam", "Pollachi", "Arakkonam", "Namakkal", "Rajapalayam"
    ],
    "Telangana": [
      "Hyderabad", "Warangal", "Karimnagar", "Nizamabad", "Khammam", "Mancherial",
      "Mahbubnagar", "Ramagundam", "Nalgonda", "Adilabad", "Suryapet",
      "Miryalaguda", "Siddipet", "Jagtial", "Bodhan", "Kamareddy", "Zaheerabad"
    ],
    "Tripura": [
      "Agartala", "Udaipur", "Dharmanagar", "Kailasahar", "Belonia", "Khowai",
      "Ambassa", "Panisagar", "Kamalpur", "Sonamura", "Sabroom"
    ],
    "Uttar Pradesh": [
      "Lucknow", "Kanpur", "Ghaziabad", "Agra", "Varanasi", "Meerut", "Prayagraj",
      "Bareilly", "Aligarh", "Moradabad", "Saharanpur", "Gorakhpur", "Noida",
      "Firozabad", "Jhansi", "Muzaffarnagar", "Mathura", "Ayodhya", "Shahjahanpur",
      "Rampur", "Etawah", "Sitapur", "Raebareli", "Lakhimpur", "Unnao", "Bulandshahr",
      "Faizabad", "Barabanki", "Fatehpur", "Hapur", "Budaun"
    ],
    "Uttarakhand": [
      "Dehradun", "Haridwar", "Haldwani", "Roorkee", "Rudrapur", "Kashipur",
      "Rishikesh", "Nainital", "Pithoragarh", "Tehri", "Almora", "Kotdwara",
      "Champawat", "Bageshwar", "Pauri", "Mussoorie"
    ],
    "West Bengal": [
      "Kolkata", "Asansol", "Siliguri", "Durgapur", "Howrah", "Bardhaman",
      "Malda", "Kharagpur", "Haldia", "Berhampore", "Jalpaiguri", "Chandannagar",
      "Bongaon", "Cooch Behar", "Serampore", "Raiganj", "Balurghat"
    ],
    "Delhi": [
      "New Delhi", "Delhi Cantonment", "Karol Bagh", "Rohini", "Dwarka",
      "Saket", "Narela", "Shahdara", "Najafgarh", "Patel Nagar", "Laxmi Nagar",
      "Rajouri Garden", "Janakpuri", "Model Town", "Vasant Kunj", "South West Delhi"
    ],
    "Jammu and Kashmir": [
      "Srinagar", "Jammu", "Baramulla", "Udhampur", "Anantnag", "Kathua",
      "Sopore", "Pulwama", "Rajouri", "Ganderbal", "Poonch", "Kupwara",
      "Bandipora", "Handwara", "Kulgam", "Budgam"
    ],
    "Ladakh": [
      "Leh", "Kargil", "Diskit", "Nubra", "Padum", "Nyoma"
    ],

  };


  return (
    <Modal
      show={show}
      onHide={handleClose}
      size="lg"
      centered
      className="fade"
    >
      <div className="row">
        <div className="col-xl-12">
          <Modal.Body>

            <Modal.Header closeButton>
              <Modal.Title>
                <i className="fa fa-plus me-2"></i>
                Add Location
              </Modal.Title>
            </Modal.Header>
            <div className="filter cm-content-box box-primary">
              <div className="content-title d-flex justify-content-between align-items-center">
                {/* <div className="cpa">
                  <i className="fa fa-plus me-2" /> Add Location
                </div> */}
                <Link
                  to="#"
                  className={`SlideToolHeader ${open2 ? 'collapse' : 'expand'}`}
                  onClick={() => setOpen2(!open2)}
                >
                  <i className="fas fa-angle-up" />
                </Link>
              </div>

              <Collapse in={open2}>
                <div className="cm-content-body form excerpt">
                  <div className="card-body">
                    <form onSubmit={handleSubmit}>
                      <div className="row">
                        <div className="form-group mb-3 col-md-6">
                          <label>Store Name</label>
                          <input
                            type="text"
                            className="form-control"
                            name="name"
                            placeholder="Store Name"
                            value={formValues.name}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div className="form-group mb-3 col-md-6">
                          <label>Location</label>
                          <input
                            type="text"
                            className="form-control"
                            name="location"
                            placeholder="Location"
                            value={formValues.location}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="form-group mb-3 col-md-6">
                          <label>Street</label>
                          <input
                            type="text"
                            className="form-control"
                            name="street"
                            placeholder="Street"
                            value={formValues.address.street}
                            onChange={handleInputChange}
                          />
                        </div>

                        {/* State Dropdown */}
                        <div className="form-group mb-3 col-md-6">
                          <label>State</label>
                          <select
                            name="state"
                            className="form-control"
                            value={formValues.address.state}
                            onChange={handleInputChange}
                          >
                            <option value="">Select State</option>
                            {Object.keys(stateCityData).map((state) => (
                              <option key={state} value={state}>
                                {state}
                              </option>
                            ))}
                          </select>
                        </div>

                        {/* City Dropdown */}
                        <div className="form-group mb-3 col-md-6">
                          <label>City</label>
                          <select
                            name="city"
                            className="form-control"
                            value={formValues.address.city}
                            onChange={handleInputChange}
                            disabled={!selectedState}
                          >
                            <option value="">Select City</option>
                            {selectedState &&
                              stateCityData[selectedState]?.map((city) => (
                                <option key={city} value={city}>
                                  {city}
                                </option>
                              ))}
                          </select>
                        </div>

                        <div className="form-group mb-3 col-md-6">
                          <label>Pincode</label>
                          <input
                            type="text"
                            className="form-control"
                            name="pincode"
                            placeholder="Pincode"
                            value={formValues.address.pincode}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="form-group mb-3 col-md-12">
                          <label>Country</label>
                          <select
                            name="country"
                            className="form-control"
                            value={formValues.address.country}
                            onChange={handleInputChange}
                          >
                            <option value="India">India</option>
                          </select>
                        </div>
                      </div>

                      <button type="submit" className="btn btn-primary me-2 mt-3">
                        Add
                      </button>
                      <button
                        type="button"
                        className="btn btn-danger mt-3"
                        onClick={() => {
                          setFormValues(initialForm);
                          setSelectedState('');
                          handleClose();
                        }}
                      >
                        Cancel
                      </button>
                    </form>
                  </div>
                </div>
              </Collapse>
            </div>
          </Modal.Body>
        </div>
      </div>

    </Modal>
  );
};

export default LocationAddModel;
